import { get, post } from "../httpServer/index";

// 记录来源
export function recordSource(type) {
  return new Promise((resolve, reject) => {
    get("/report/inter/add", { type })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// 提交表单
export function submitForm(params) {
  return new Promise((resolve, reject) => {
    post("/report/inter/create", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
